import { bootstrapWeb } from "@/bootstrap-web";

bootstrapWeb();
